import { useId } from 'react';
import { Card, Typography } from '@mui/material';
import { Totals } from 'models/data';
import { MeasureFormat } from 'components/measure-unit/MeasureFormat';
import { trackMatomoEvent } from 'services/matomo.service';
import { Measure } from 'services/model/model.service';
import { MeasureCard } from './MeasureCard';

export function MeasureCardRow({
  measures,
  secondaryMeasures = undefined,
  testid = undefined,
  totalsData,
  selectedMeasureCode = undefined,
  onMeasureSelect = undefined,
  customComparisonPeriod = undefined,
  detectionDate = undefined,
}: {
  measures: Measure[];
  secondaryMeasures?: Measure[];
  testid?: string;
  totalsData: Totals;
  selectedMeasureCode?: string;
  onMeasureSelect?: (measure: Measure) => () => void;
  customComparisonPeriod?: string;
  detectionDate?: string;
}) {
  const instanceId = useId();

  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-4 w-full xl:col-span-12 col-span-6" data-testid={testid}>
      {measures.map((measure, i) => {
        const handleMeasureSelect = () => {
          trackMatomoEvent({
            action: 'MeasureCardRow',
            name: {
              defaultNamePrefix: 'measure-section',
              details: [measure.code],
              testid,
              instanceId,
            },
            includePageContextInAction: true,
          });
          onMeasureSelect?.(measure)();
        };

        return (
          <div className="grid grid-cols-1 gap-4" key={measure.code}>
            <MeasureCard
              testid={testid}
              measure={measure}
              totals={totalsData}
              selected={measure.code === selectedMeasureCode}
              onSelect={onMeasureSelect ? handleMeasureSelect : undefined}
              customComparisonPeriod={customComparisonPeriod}
              detectionDate={detectionDate}
            />

            {secondaryMeasures && secondaryMeasures[i] && (
              <Card
                sx={{
                  boxShadow: 0,
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  paddingX: 5,
                  paddingY: 3,
                  gap: 3,
                  height: '100%',
                }}
              >
                <Typography variant="h4" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                  {secondaryMeasures[i].metric.name}
                </Typography>
                <Typography variant="subtitle1">
                  <MeasureFormat
                    value={totalsData.values[secondaryMeasures[i].code] ?? 0}
                    unit={secondaryMeasures[i].metric.unit}
                  />
                </Typography>
              </Card>
            )}
          </div>
        );
      })}
    </div>
  );
}
